import image from './snake.mp4';
import text from './text';

export const story = {
    slug: 'snake',
    title: 'Snake',
    interactive: 'snake',
    img: image,
    year: 'slip slimey scraps',
    tags: ['horror'],
    md: text,
}